// import { Radar } from "@ant-design/charts";
import { Radar } from "@ant-design/plots";
import { useEffect, useState } from "react";
import cyanBadge from "../../assets/badges/stats_cyan_badge.png";
import greenBadge from "../../assets/badges/stats_green_badge.png";
import pinkBadge from "../../assets/badges/stats_pink_badge.png";
import AwsAxios from "../../utils/AwsAxios";
import LoadingCom from "../LoadingCom";

const StatsRadial = () => {
  return (
    <div className="p-5 bg-pureWhite min-h-[450px] items-center rounded-xl">
      <p className="font-semibold text-lg">Statistics</p>
      <div className="flex mt-3">
        {/* <div className="flex flex-col justify-around w-[60px]">
          <div className="flex flex-col items-center">
            <img
              src={cyanBadge}
              alt="badge"
              className="max-w-[36px] max-h-[64px]"
            />
            <p className="mt-2 text-[14px] font-semibold">370</p>
            <p className="text-[10px] mt-[-3px]">PTS</p>
          </div>
          <div className="flex flex-col items-center">
            <img
              src={pinkBadge}
              alt="badge"
              className="max-w-[36px] max-h-[64px]"
            />
            <p className="mt-2 text-[14px] font-semibold">133</p>
            <p className="text-[10px] mt-[-3px]">PTS</p>
          </div>
          <div className="flex flex-col items-center">
            <img
              src={greenBadge}
              alt="badge"
              className="max-w-[36px] max-h-[64px]"
            />
            <p className="mt-2 text-[14px] font-semibold">133</p>
            <p className="text-[10px] mt-[-3px]">PTS</p>
          </div>
        </div> */}
        <div className=" flex items-center justify-center mx-auto">
          <DemoSunburst />
        </div>
      </div>
    </div>
  );
};

const DemoSunburst = () => {
  
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const asyncFetch = async () => {
    setLoading(true);
    try {
      const response = await AwsAxios.get(
        "https://rh8swmj6we.execute-api.us-east-2.amazonaws.com/Prod/radial-graph-widget"
      );
      if (response && response?.data) {
        const apiData = response?.data;
        console.log(apiData, "apiDataaaaaaaaaa");
        // Assuming the structure of apiData is correct as you described
        setData(apiData?.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Fetch data failed", error);
    }
  };

  // console.log(data, "dataaaaaa");

  // const data = [
  //   { item: "Design", type: "a", score: 70 },
  //   { item: "Design", type: "b", score: 30 },
  //   { item: "Development", type: "a", score: 60 },
  //   { item: "Development", type: "b", score: 70 },
  //   { item: "Marketing", type: "a", score: 50 },
  //   { item: "Marketing", type: "b", score: 60 },
  //   { item: "Users", type: "a", score: 40 },
  //   { item: "Users", type: "b", score: 50 },
  //   { item: "Test", type: "a", score: 60 },
  //   { item: "Test", type: "b", score: 70 },
  //   { item: "Language", type: "a", score: 70 },
  //   { item: "Language", type: "b", score: 50 },
  //   { item: "Technology", type: "a", score: 50 },
  //   { item: "Technology", type: "b", score: 40 },
  //   { item: "Support", type: "a", score: 30 },
  //   { item: "Support", type: "b", score: 40 },
  //   { item: "Sales", type: "a", score: 60 },
  //   { item: "Sales", type: "b", score: 40 },
  //   { item: "UX", type: "a", score: 50 },
  //   { item: "UX", type: "b", score: 60 },
  // ];

  useEffect(() => {
    asyncFetch();
  }, []);
  const config = {
    data,
    xField: 'item',
    yField: 'score',
    colorField: 'type',
    shapeField: 'smooth',
    area: {
      style: {
        fillOpacity: 0.5,
      },
    },
    scale: { x: { padding: 0.5, align: 0 }, y: { tickCount: 5, domainMax: 10 } },
    axis: { x: { grid: true }, y: { zIndex: 1, title: false } },
    style: {
      lineWidth: 2,
    },
  
  };
  const radarStyle = {
    width: '400px', // Set desired width
    height: '400px', // Set desired height
  };
  return (
    <div >
    {data && data.length > 0 ? (
      <div style={radarStyle}><Radar {...config} /></div>
    ) : (
      <div className="w-full">
        <LoadingCom />
      </div>
    )}
  </div>
  );
};

export default StatsRadial;
